// Pure helpers for the "תפוס" (held) face state shared by the guest galleries (Swingies / MiniMove).
//
// Identity: the server holds a head by its BASENAME, case-insensitively (face_claims.face_id), while the
// gallery list (/api/faces) and the held list (/api/face-claims) are two different cache reads whose full
// paths can differ in the event-folder spelling. Comparing whole path strings therefore silently reads a held
// head as free. Every comparison here is by the normalized basename instead.

export const HELD_EDITING = "editing";
export const HELD_PROCESSING = "processing";

// "/Events/X/faces/ready/Head%201.PNG?x=1" -> "head 1.png"
export const faceKey = (path) => {
  if (typeof path !== "string" || !path) return "";
  let name = path.split("?")[0].replace(/\\/g, "/");
  name = name.slice(name.lastIndexOf("/") + 1);
  try {
    name = decodeURIComponent(name);
  } catch (error) {
    // not percent-encoded: keep the literal name
  }
  return name.normalize("NFC").toLowerCase();
};

// GET /api/face-claims body -> { states: { [faceKey]: "editing" | "processing" } }.
// `held_states` ({path: state}) is the current contract; a legacy body with only `held` ([path]) reads as
// editing. Anything else is a malformed reply (the caller treats it as an error, never as "nothing held").
export const parseHeldBody = (body) => {
  if (!body || typeof body !== "object" || !Array.isArray(body.held)) return null;
  const states = {};
  const stated = body.held_states && typeof body.held_states === "object" ? body.held_states : {};
  body.held.forEach((path) => {
    const key = faceKey(path);
    if (!key) return;
    states[key] = stated[path] === HELD_PROCESSING ? HELD_PROCESSING : HELD_EDITING;
  });
  return { states, reusable: body.reusable === true };
};

export const heldSubLabel = (state) => (state === HELD_PROCESSING ? "בעיבוד" : "בעריכה");
